import React from "react";
import { useRouter } from "next/router";
import { Formik, Form } from "formik";

import { STEPS, STEP_ACCOUNT, STEP_ADDRESS, STEP_PRODUCT_COLLECTION, STEP_SHIPPING } from "../../constants";
import FormActions from "./FormActions";
export default function FunnelFormik({
  initialValues,
  validationSchema,
  submitText,
  submitAction,
  step,
  children,
  setSubmitFormik,
  goBack,
  onSubmit,
}) {
  const router = useRouter();
  const nextStep = STEPS[STEPS.findIndex((s) => s === step) + 1];
  const prevStep =
    STEPS[STEPS.findIndex((s) => s === step) - 1] === STEP_ACCOUNT ||
    STEPS[STEPS.findIndex((s) => s === step) - 1] === STEP_PRODUCT_COLLECTION
      ? STEPS[STEPS.findIndex((s) => s === step) - 2]
      : STEPS[STEPS.findIndex((s) => s === step) - 1];

  const isNextableStep = (values) => {
    return (
      step !== STEP_ACCOUNT &&
      !(step === STEP_SHIPPING && !values.date) &&
      step !== STEP_ADDRESS &&
      step !== STEP_PRODUCT_COLLECTION
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values, formik) => {
        onSubmit && onSubmit();
        formik.setSubmitting(false);
        submitAction(values, formik.setErrors);
        isNextableStep(values) && router.push(`/reconditionne/panier/${nextStep}`);
      }}
    >
      <Form>
        {children}
        <FormActions
          step={step}
          prevStep={prevStep}
          submitText={submitText}
          goBack={goBack}
          setSubmitFormik={setSubmitFormik}
        />
      </Form>
    </Formik>
  );
}
